import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableAdjustmentDeliveryNotes from '../../../../../../specificComponents/inputTableLayouts/order/OrderAdjustmentDeliveryNoteLayout/TableAdjustmentDeliveryNotes'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateAdjustmentDeliveryNote from './ModalCreateAdjustmentDN'

interface AdjustmentDeliveryNotesProps extends ComponentWithPermissions { }

const AdjustmentDeliveryNotes: React.FC<AdjustmentDeliveryNotesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('adjustmentDeliveryNotes', 'Albaranes de regularización'),
        newText: t('newAdjustmentDeliveryNote', 'Nuevo albarán de regularización'),
    }

    return (
        <BaseScreenTable TableComponent={TableAdjustmentDeliveryNotes} CreateModalComponent={ModalCreateAdjustmentDeliveryNote} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default AdjustmentDeliveryNotes